import React, { Component } from "react";
import "./Careers.css";
import imap from "../images/car-img/india_map.svg";
import chat from "../images/car-img/chat-love-icon.svg";
import bulb from "../images/car-img/light-bulb-icon.svg";
import stars from "../images/car-img/stars-icon.svg";
class Careers extends Component {
  render() {
    return (
      <>
        <div className="text-center my-5">
          <h1 className="my-5">Careers</h1>
          <h2>Become A GIMSanian</h2>
          <h3>
            We’re hiring across all disciplines, from operations to engineering.
          </h3>
        </div>

        <div className="container">
          <div className="container">
            <div className="open-positions fs-1 rounded-5 mx-5 text-center py-4">
              <a href="#!" className="text-decoration-none text-light">
                View Open Positions
              </a>
            </div>
          </div>
        </div>
        <div className="container my-5">
          <div className="row">
            <div className="col">
              <h1 className="text-center">Our Mission</h1>
              <div>
                <p>We’re revolutionizing the way India shops.</p>
              </div>
              <img alt="" src={imap} className="img-fluid" />
            </div>
            <div className="col">
              <h1 className="text-center">How We Work</h1>

              <div className="row my-5">
                <p>
                  <img alt="" src={stars} width="50px" height="50px" /> Move
                  fast and deliver things
                </p>
                <p>
                  GIMS is defined as the shortest unit of measurable time in
                  physics, which means speed is in our DNA. From delighting
                  customers with 10-minute delivery to growing our presence
                  across the country, speed is always at the forefront.
                </p>
              </div>
              <div className="row">
                <p>
                  <img alt="" src={bulb} width="50px" height="50px" /> Question
                  what's possible
                </p>
                <p>
                  10-minute delivery sounds crazy, which is why we believe in
                  breaking existing mental models and creating radically new
                  ideas. Our team includes India’s top talent in ops,
                  engineering, marketing and we pride ourselves in first
                  principles thinking.
                </p>
              </div>
              <div className="row">
                <p>
                  <img alt="" src={chat} width="50px" height="50px" /> Customer
                  obsession
                </p>
                <p>
                  Customer experience is our everything. From product to
                  operations, we push ourselves beyond what's "practical" in our
                  never ending pursuit of delivering customer delight.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center">
          <h1 className="fs-1">Open Positions</h1>
          <p className="fs-2">
            We're hiring across the board in engineering, marketing and ops.
          </p>
        </div>
      </>
    );
  }
}
export default Careers;
